import React from "react";
import { Check, X } from "lucide-react";
import { COMPARISON } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Comparison() {
  const r = useReveal();
  return (
    <section className="bg-ls py-20 md:py-28">
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">Real talk</p>
        <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl max-w-4xl mb-5">
          Big agency, or one guy who actually does the work.
        </h2>
        <p className="text-lg text-[#b7ab9b] max-w-3xl mb-12">
          You already know how a big agency ends. Sold by a closer. Handed to somebody's kid. A dashboard full of
          impressions. No booked jobs. Here's the honest version.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Big agency */}
          <div
            className="rounded-lg p-8"
            style={{ background: "var(--ls-surface)", border: "1px solid var(--ls-border)" }}
          >
            <h3 className="font-cond font-extrabold text-2xl uppercase tracking-wide text-[#d7cdbf] mb-6">
              {COMPARISON.agency.title}
            </h3>
            <ul className="space-y-4">
              {COMPARISON.agency.items.map((item, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#3a2020] shrink-0 mt-0.5">
                    <X className="w-3.5 h-3.5 text-red-400" strokeWidth={3} />
                  </span>
                  <span className="text-[#b7ab9b] leading-snug">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Working with me */}
          <div
            className="rounded-lg p-8 relative overflow-hidden"
            style={{ background: "var(--ls-surface)", border: "1px solid rgba(242,106,33,0.5)" }}
          >
            <div
              className="pointer-events-none absolute -top-24 -right-24 w-64 h-64 rounded-full opacity-20"
              style={{ background: "radial-gradient(circle, #f26a21, transparent 70%)" }}
            />
            <h3 className="font-cond font-extrabold text-2xl uppercase tracking-wide text-white mb-6">
              {COMPARISON.me.title}
            </h3>
            <ul className="space-y-4">
              {COMPARISON.me.items.map((item, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <span
                    className="flex items-center justify-center w-5 h-5 rounded-full shrink-0 mt-0.5"
                    style={{ backgroundColor: "var(--ls-orange)" }}
                  >
                    <Check className="w-3.5 h-3.5" stroke="#0a0f16" strokeWidth={3} />
                  </span>
                  <span className="text-[#ece5da] leading-snug">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
